// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.radio-group-input[data-v-45a03f32] .radio-group--column .input-group__input {
  display: inherit;
}
.radio-group-input[data-v-45a03f32] .v-input--radio-group .input-group {
  padding: inherit;
}
.radio-inline-custom[data-v-45a03f32] {
  position: relative;
  padding-left: 33px;
  cursor: pointer;
}
.radio-inline-custom[data-v-45a03f32] .v-radio {
  position: absolute;
  left: 0px;
  top: 5px;
}
.radio-group-custom[data-v-45a03f32] .v-input--radio-group .v-input {
  padding-top: 0px;
  margin-top: 0px;
}
.radio-inline-custom[data-v-45a03f32] label {
  width: auto;
}
.radio-inline-custom[data-v-45a03f32] .v-input input {
  color: #e91e63 !important;
  font-weight: 600;
}
.radio-group-custom[data-v-45a03f32] .v-input--radio-group > .v-input__control {
  padding-top: 0px;
  padding-left: 8px;
}
.radio-inline-custom[data-v-45a03f32] .v-text-field:not(.radio) {
  padding-left: 50px;
}
.radio-group-custom[data-v-45a03f32] .v-input--radio-group .error--text .input-group__messages {
  color: #ff5252 !important;
}
.custom-value[data-v-45a03f32] .v-input input {
  opacity: 0;
}
/*PhoneNumber Component*/
.internal-phone-number[data-v-45a03f32] {
  width: 100%;
}
.internal-phone-number[data-v-45a03f32] .contact-number .input-group .v-text-field__details {
  opacity: 1;
  padding-right: 0px;
}
.internal-phone-number[data-v-45a03f32] .call-number-txt {
  max-width: calc(100% - 50px);
  display: inline-block;
  padding-left: 0 !important;
  width: 100%;
}
.internal-phone-number[data-v-45a03f32] .selectedCountry {
  max-width: 50px;
  display: inline-block;
  position: static;
  padding-left: 0 !important;
  vertical-align: top;
}
.internal-phone-number[data-v-45a03f32] .selectedCountry .v-select__slot,
.internal-phone-number[data-v-45a03f32] .validation,
.internal-phone-number[data-v-45a03f32] .contact-number .v-text-field__slot {
  opacity: 0;
}
.radio-group-custom[data-v-45a03f32] .v-input__control {
  width: 100%;
}
.radio-group-custom[data-v-45a03f32] .contact-number .v-input__control .v-input__slot:after,
.radio-group-custom[data-v-45a03f32] .contact-number .v-input__control .v-input__slot:before {
  opacity: 1;
}
.radio-group-input[data-v-45a03f32] {
  margin-top: 0;
}
.show-number[data-v-45a03f32] .contact-number .v-input__control .v-input__slot:after,
.show-number[data-v-45a03f32] .contact-number .v-input__control .v-input__slot:before {
  opacity: 1 !important;
}
.radio-group-input[data-v-45a03f32] .v-input .v-input__slot {
  margin-bottom: 6px !important;
}
.radio-group-input[data-v-45a03f32] .v-input .v-text-field__details {
  min-height: 20px;
}
.call-preference-reason[data-v-45a03f32] {
  padding-left: 87px;
  padding-right: 20px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
